export enum SelectionMode {
    SINGLE = 'SINGLE',
    MULTIPLE = 'MULTIPLE',
    RANGE = 'RANGE',
}
